import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEarthAmericas } from "@fortawesome/free-solid-svg-icons";
import Back from "../common/back-button";
import SkillPill from "../common/skill-pill";
import Thanks from "../common/thanks";
import Footer from "../common/footer";
import Meta from "../common/meta";
import { MacEmulator } from "../common/mac-emulator";

const selectedSkills = [
  "Next.js",
  "TypeScript",
  "React",
  "HTML5",
  "Tailwind",
  "Node.js",
  "AWS",
  "Vercel",
  "Payload",
  "PostgreSQL",
];

const FortiFi = () => {
  return (
    <>
      <Meta
        title="40fi"
        description="Case study for the 40fi website overhaul using Next.js, TypeScript, Tailwind, and Payload CMS integration."
      />

      <header id="header-about">
        <Back />
      </header>

      <main id="main-content">
        {/* TITLE */}
        <section>
          <div id="title-container" style={{ gap: "2rem" }}>
            <h1>40fi</h1>
            <p className="para">
              Overhaul of 40fi&#39;s website, content powered by Payload CMS integration with
              Next.js, TypeScript and Tailwind.
            </p>
          </div>

          {/* HERO AREA */}
          <div className="portfolio-hero-container" style={{ marginTop: "3rem" }}>
            <MacEmulator>
              <img
                src="https://res.cloudinary.com/drrscrxod/image/upload/q_auto/f_auto/40fi_ftupsr.webp"
                alt="40fi screenshot"
                style={{ width: "100%", height: "auto" }}
              />
            </MacEmulator>

            <div className="links-container">
              <ul>
                <Link to="https://www.40fi.net/" target="_blank" rel="noopener noreferrer">
                  <li className="pill active">
                    <FontAwesomeIcon className="icon" icon={faEarthAmericas} alt="GitHub" />
                    40fi.net
                  </li>
                </Link>
              </ul>
            </div>
          </div>
        </section>

        {/* MAIN COPY */}
        <section className="portfolio-copy">
          <p className="para black">
            40fi came to node london with a need for a complete overhaul of their website. The goal
            was to create a modern, responsive website that showcased their services and expertise
            in the security industry, whilst enabling them to easily manage content through a new
            Payload CMS integration.
          </p>
          <p className="para black">
            The project involved a complete redesign and development of the website using Next.js,
            TypeScript, and Tailwind CSS. The new site features a clean, modern design that is fully
            responsive, ensuring a seamless user experience across all devices.
          </p>
          <p className="para black">
            Beyond front-end development, I worked across the stack to deliver a robust integration
            with Payload CMS. This included designing and implementing the API calls, defining the
            content models, and migrating and structuring the PostgreSQL database that sat behind
            the Payload CMS integration.
          </p>
          <p className="para black">
            The integration with Payload CMS now allows 40fi to easily manage their content,
            including blog posts, service pages, and case studies, without needing to rely on a
            developer for every update.
          </p>
        </section>

        {/* IMAGES AND LINKS */}
        <div className="two-col-content">
          <MacEmulator>
            <img
              src="https://res.cloudinary.com/drrscrxod/image/upload/q_auto/f_auto/40fi-contact_xs8ohm.webp"
              alt="40fi contact page screenshot"
            />
          </MacEmulator>
          <img
            src="https://res.cloudinary.com/drrscrxod/image/upload/c_scale,w_500/q_auto/f_auto/40fi-resource_uogwpr.webp"
            alt="40fi resources page screenshot"
          />
        </div>

        {/* TECH USED SECTION */}
        <section>
          <h2>Technologies Used:</h2>
          <SkillPill selectedSkills={selectedSkills} />
        </section>

        {/* THANKS SECTION */}
        <section>
          <Thanks />
        </section>
      </main>

      {/* FOOTER */}
      <Footer />
    </>
  );
};

export default FortiFi;
